<template>
    <div class="add-work-phone">
        <div class="content">
            <div class="data-title">
                <div class="title-name">新增工作手机号</div>
            </div>
            <div class="text">基本信息</div>
            <div class="forms">
                <el-form :inline="true" :model="form" ref="form" :rules="rules" class="form" size="small" label-width="96px">
                    <el-form-item label="工作手机号" prop="phone">
                        <el-input v-model="form.phone" placeholder="请输入" maxlength="11" clearable show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="运营商" prop="phoneOperator">
                        <el-select v-if="dictionaries.phone_operator" v-model="form.phoneOperator" placeholder="请选择">
                            <el-option v-for="item in dictionaries.phone_operator" :key="item.dictId" :label="item.dictName"
                                :value="item.dictId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="实名人" class="t-label">
                        <el-input v-model="form.name" placeholder="请输入" clearable maxlength="30" type="textarea" style="width: 204px;" rows="3" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="手机号备注" class="t-label" prop="remarks">
                        <el-input v-model="form.remarks" placeholder="请输入" clearable maxlength="64" type="textarea" style="width: 204px;" rows="3" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="footer" :class="[isCollapsed ? 'footer-collapsed' : '']">
                <el-button type="info" plain @click="back">返回</el-button>
                <el-button type="primary" plain @click="reset">重置</el-button>
                <el-button type="primary" @click="save" :loading="btnSave">保存</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import { REGEX } from '@/pages/assetManagement/common/consts/regex.js';
export default {
    name: 'workPhoneAdd',
    computed: {
        isCollapsed() {
            return this.$store.state.isCollapsed
        }
    },
    data() {
        return {
            dictionaries: {
                 phone_operator: [],
            },
            form: {
                phone: '',
                phoneOperator: '',
                name: '',
                remarks: '',

            },
            btnSave: false,
            rules: {
                phone: [
                    { required: true, message: '请输入工作手机号', trigger: 'blur' },
                    { pattern: REGEX.PHONE, message: '请输入11位手机号', trigger: ['blur','change'] }
                ],
                phoneOperator: [
                    { required: true, message: '请选择手机运营商', trigger: 'blur' }
                ],
            },
        }
    },
    activated() {
        this.reset()
    },
    created() {
        for(const type in this.dictionaries){
            this.getDictionaries(type)
        }
    },
    methods: {
        
        back() {
            this.$router.go(-1)
        },
        reset() {
           this.form = {}
           this.$refs.form.resetFields()
        },
        save() {
            console.log('>>', this.form)
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.btnSave = true
                    this.$api.workPhoneSave(this.form).then((res) => {
                        if (res.code == 0) {
                            this.$message({ message: '新增成功', type: 'success' })
                            this.back()
                        }
                    }).finally(() => {
                        this.btnSave = false
                    })
                }
            })
        },
        //获取字典数据
        getDictionaries(type){
          if(type && this.dictionaries[type].length > 0){
            return
          }
          const params = { groupId: type }
          this.$api.dictionaries(params).then(res => {
            this.dictionaries[type] = res.data || []
          }).catch((err) => {
                console.log(err)
            })
         },
    },
}
</script>
<style lang="scss" src="@/pages/assetManagement/common/style/workPhone.scss" scoped />